<template>
  <div class="informatedisclosure">
    <header-view curr="4"></header-view>
    <div class="body">
	  
	  <div class="toptitle">
	  		<div class="left_c">
				<div class="redcon"></div>
				<span>信息公开</span>
			</div>
			<div class="right_c">
				<div class="searchcon">
					 <input class="inputa" v-model="searchv" placeholder="请输入"
					 @input="changeinput"/>
					 <img class="imgcon" src="../assets/searchimg.png" alt="" 
					 @click="changeinput"/>
				</div>
			</div>
	  </div>
	  
      <div class="centent">
		  <div class="lista">
			  <div v-for="(item, index) in typelist" class="listsignle"
			  @click="changetab(index)">
				  <div :class="index == indexsign?'signlea_cur':'signlea'"> 
						<div>{{item}}</div> 
				  </div> 
				  <div :class="index == indexsign?'':'linecon'"></div>	
			  </div>
		  </div>
		  <div class="listb">
			 <div v-for="(item, index) in list">
				  <!-- <router-link :to="'/noticeDetails?index=' + index + '&id=' + item.id"> -->
				  <div @click="toDatail(index,item)" class="signleb">
						<div class="titlecon">
							{{item.title || ''}}
						</div>
						<div class="timecon">
							{{item.createTime || ''}} 
						</div>
				  </div>
				  <!-- </router-link> -->
			 </div> 
		  </div>
		  
      </div>
	  
      <zhini-pagination
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
	  
    </div>
  </div>
</template>

<script>
import zhiniPagination from "../components/zhini-pagination.vue";
export default {
  name: "informatedisclosure",
  components: {
    zhiniPagination
  },
  data: function() {
    return {
      list: "",
      pageNo: 1,
      pageSize: 15,
      totalPage: 0,
      url: "",
	  
	  typesign:0,
	  
	  indexsign:0,
	  // typelist:["项目备案","捐款公示","年度报告","审计报告","免税信息"],
	  typelist:["财务报告","审计报告","评估报告","年检报告","年度工作报告","项目备案","免税信息"],
	  searchv:"", 
	  
    };
  },
  created() {	  
		this.init();	
  },
  watch:{
  		$route(){
  		      this.typesign = this.$route.query.type
  		},
  	    typesign() {
  	      	this.typesign = this.$route.query.type
  			this.init()
  	    },
  },
  methods: {
	//搜索
	changeinput(){
		this.init()
	},
	  
	//变化类型  
	changetab(index){
		  this.indexsign = index;
		  this.init();
	},
	  
    toDatail(indexsign,item){
		this.$router.push({ path: '/informatedisclosuredetail', query: {index:indexsign,id:item.id} });
	},
 
    init() {
      var that = this;
	  var infotype = 0;
	  if(this.indexsign == 0){
		  infotype = 0;
	  }else if(this.indexsign == 1){
		  infotype = 4; 
	  }else if(this.indexsign == 2){
		  infotype = 0;
	  }else if(this.indexsign == 3){
		  infotype = 0;
	  }else if(this.indexsign == 4){
		  infotype = 6;
	  }else if(this.indexsign == 5){
		  infotype = 2;
	  }else if(this.indexsign == 6){
		  infotype = 5;
	  }
      this.httpGet("web/info/list", {
		infoType:infotype,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
		title:this.searchv,
      }).then(res => {
        that.list = res.result.records;
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;	
		
      this.pageNo = e;
      this.init();
    }
  },
  mounted() {}
};
</script>
<style scoped="scoped" lang="scss">
::-webkit-scrollbar {
            width: 0px;
        }
.informatedisclosure {
  // background: #f4f5f9;
  width: 100%;
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    min-height: 10rem;
	// height: 100%;
    background: #ffffff;
    margin: 2.22rem auto 0;
    padding: 0 0.7rem;
    overflow: hidden;
    .centent {
      width: 10.22rem;
      margin: 0.2rem auto;
      .lista{
		 width: 100%;
		 height: 0.37rem;
		 background: #FBFBFB;
		 display: flex;
		 align-items: center;
		 cursor: pointer;
		 .listsignle{
			display: flex;
			align-items: center; 
		 }
		 .signlea{
			width: 1.07rem;
			height: 0.37rem;
			line-height: 0.37rem;
			text-align: center;
			color: #666666;
			font-size: 0.16rem;	
		 }
		 .signlea_cur{
			width: 1.07rem;
			height: 0.37rem;
			line-height: 0.37rem;
			text-align: center;
			background: #E70012; 
			color: #FFFFFF;
			font-size: 0.16rem;	
		 }
		 .linecon{
			 width: 0.01rem;
			 height: 0.17rem;
			 background: #666666;
			 opacity: 0.3;
		 }
		 
	  }
	  
	  .listb{
		  max-height: 7.5rem;
		  overflow-y: auto;
		  margin-top: 0.4rem;
		  .signleb{
			  cursor: pointer;
			  height: 0.5rem;
			  display: flex;
			  align-items: center;
			  justify-content: space-between;
			  font-size: 0.16rem;
			  font-weight: bold;
			  color: #333333;
			  border-bottom: 1px solid #E6E6E6;
			  .titlecon{
				  font-size: 0.18rem;
				  font-weight: 400;
				  color: #333333;
			  }
			  .titlecon:hover {
			      color: rgba(230, 31, 38, 1);
			  }
			  .timecon{
				  font-size: 0.12rem;
				  font-weight: 400;
				  color: #999999;
			  }
		  }
	  }
	  
	 
    }
    .zhini-pagination {
	  position: absolute;
	  bottom: 0.1rem;
	  width: 100%;
	  left: 0;
    }
	
	.toptitle{
		height: 0.6rem;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 0.05rem;
				height: 0.2rem;
				background: #E70012;
				margin-right: 0.2rem;
			}
			font-size: 0.18rem;
			font-weight: 400;
			color: #E61F26;
		}
		.right_c{
			// margin-right: 0.2rem;
			.searchcon{
				height: 0.4rem;
				line-height: 0.4rem;
				width: 2.68rem;
				background: #F1F1F1;
				border-radius: 0.15rem;
				padding-left: 0.2rem;
				padding-right: 0.2rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.inputa{
					font-size: 0.14rem;
				}
				.imgcon{
					height:0.18rem;
					width: 0.18rem;
				}
			}
		}
	}
	
	
  }
}
</style>
